import { useState, useRef, useEffect } from "react";
import HdfcPaymentButton from "./HDFCPaymentButton";
import { useLocation } from "react-router-dom";
import Payment from "./Payment";

export default function SelectPaymentGateway() {
    // const location = useLocation();
    // const { data, currentService: navService } = location.state || {};
    const [isProcessing, setIsProcessing] = useState(false);
    const [details, setDetails] = useState( null);
    const [currentService, setCurrentService] = useState(null);

    

    const [selectedGateway, setSelectedGateway] = useState("razorpay");
    // const razorpayRef = useRef(null);
    // const hdfcRef = useRef(null);

useEffect(() => {
  const storedData = localStorage.getItem("paymentDetails");
  const storedService = localStorage.getItem("currentService");

  if (!storedData || !storedService) {
    console.error("❌ Payment data missing in localStorage");
    return;
  }

  try {
    const parsedData = JSON.parse(storedData);
    const serviceDetails = parsedData?.[`${storedService}Details`];

    if (!serviceDetails) {
      console.error("❌ Service details missing", storedService);
      return;
    }

    setDetails(serviceDetails);      // ✅ CORRECT
    setCurrentService(storedService); // ✅ CORRECT

  } catch (err) {
    console.error("❌ Failed to parse paymentDetails", err);
  }
}, []);


 if (!details || !currentService) {
    return (
      <div className="h-screen flex items-center justify-center">
        <p className="text-gray-600">Preparing payment…</p>
      </div>
    );
  }



    const commonProps = {
        orderId: `order_${Date.now()}`,
        amount: details?.charges,
        customerId: details?.CustomerCode,
        customerEmail: details?.email,
        customerPhone: details?.CustomerPhone,
        firstName: details?.CustomerName,
        AccidentVehicleCode: details?.AccidentVehicleCode,
        vendorcode: details?.VendorCode,
        vendorType: currentService,
        vehicleNo: details?.vehicleNo,
    };
    console.log("Payment Details:-------------- ", commonProps);

    const hdfcProps = {
        ...commonProps,
        description: "Complete your payment",
        returnUrl: `${process.env.REACT_APP_BACKEND_URL}/api/payment-response`,
        payment_page_client_id: "SG2890",
        action: "paymentPage",
    };

    const razorpayProps = {
        ...commonProps,
        description: "Complete your payment via Razorpay",
    };

    const handleContinue = () => {
    if (
        !details?.AccidentVehicleCode ||
        !details?.VendorCode ||
        !details?.vehicleNo ||
        !currentService
    ) {
    alert("Payment details not ready. Please try again.");
    return;
    }

        setIsProcessing(true);
    };

    return (
      <div className="font-satoshi flex flex-col h-screen p-4">
        <h1 className="text-2xl text-left font-bold mb-[3rem] mt-[1rem]">
          Select Payment Gateway
        </h1>

        <div className="flex flex-col items-center space-y-4 mb-8">
          {["hdfc", "razorpay"].map((gateway) => (
            <label
              key={gateway}
              style={{
                border:
                  selectedGateway === gateway
                    ? "2px solid #2563eb"
                    : "1px solid transparent",
                borderRadius: "0.75rem",
                padding: "1rem",
                // width: "24rem",
                cursor: "pointer",
                boxShadow:
                  selectedGateway === gateway
                    ? "0 0 10px rgba(37, 99, 235, 0.5)"
                    : "0 0 10px rgba(0, 0, 0, 0.5)",
              }}
              className="flex flex-row-reverse justify-between items-center w-full max-w-md rounded-xl p-4 cursor-pointer shadow-md transition-all duration-200"
            >
              <input
                type="radio"
                name="gateway"
                value={gateway}
                checked={selectedGateway === gateway}
                onChange={() => setSelectedGateway(gateway)}
                className="ml-2"
              />
              <span className="text-lg">
                Pay via {gateway === "hdfc" ? "HDFC" : "Razorpay"}
              </span>
            </label>
          ))}
        </div>

        {/* Hidden buttons to trigger payment */}
        {isProcessing && (
          <div className="hidden">
            {selectedGateway === "razorpay" && <Payment {...razorpayProps} />}
            {selectedGateway === "hdfc" && <HdfcPaymentButton {...hdfcProps} />}
          </div>
        )}

        <button
          onClick={handleContinue}
          disabled={isProcessing}
          className={`fixed bottom-[3rem] left-1/2 -translate-x-1/2 bg-blue-600 text-white px-6 py-3 rounded-lg w-[90%] max-w-md transition flex justify-center items-center gap-2 ${
            isProcessing ? "opacity-50 cursor-not-allowed" : "hover:bg-blue-700"
          }`}
        >
          {isProcessing && (
            <svg
              className="animate-spin h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              />
            </svg>
          )}
          <span>{isProcessing ? "Processing..." : "Continue"}</span>
        </button>
        {isProcessing && (
          <div className="fixed inset-0 z-[9999] bg-white/80 flex items-center justify-center">
            <div className="loader2 h-[50px] w-[20px]"></div>
          </div>
        )}
      </div>
    );
}
